import { Box, Stack, Switch, TextField, Typography } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useState } from 'react'

import Show from '../../Layout/Can/Show'
import { useAuth } from '../../Shared/Contexts/AuthContext'

const Publication = ({ onChange }) => {
  const [publication, setPublication] = useState()
  const {
    currentUser: { isSuperAdmin }
  } = useAuth()

  const handleChange = (event) => {
    setPublication({
      ...publication,
      [event.target.name]: event.target.checked
    })
  }

  const handleOdlCodeChange = (event) => {
    setPublication({
      ...publication,
      odlCode: event.target.value
    })
  }

  const handleLocationCodeChange = (event) => {
    setPublication({
      ...publication,
      locationCode: event.target.value
    })
  }

  useEffect(() => {
    onChange(publication)
  }, [publication])

  return (
    <Stack
      direction="column"
      spacing={5}
    >
      <Typography
        variant="h2"
        py={1}
      >
        {t('devices.addPublication')}
      </Typography>

      <Show when={() => isSuperAdmin}>
        <Stack direction="column">
          <Typography variant="h4">ODL Code</Typography>
          <TextField
            type="string"
            variant="standard"
            value={publication?.odlCode}
            onChange={handleOdlCodeChange}
            sx={{ mb: 5 }}
          />
          <Typography variant="h4">Location Code</Typography>
          <TextField
            type="string"
            variant="standard"
            value={publication?.locationCode}
            onChange={handleLocationCodeChange}
            sx={{ mb: 5 }}
          />
        </Stack>
      </Show>

      <Stack direction="row">
        <Box width="100%">
          <Typography variant="h3">{t('devices.public')}</Typography>
          <Typography variant="body2">{t('devices.publicInfo')}</Typography>
        </Box>
        <Switch
          name="isPublic"
          checked={publication?.isPublic || false}
          onChange={handleChange}
          slotProps={{ input: { 'aria-label': t('devices.public') } }}
        />
      </Stack>
    </Stack>
  )
}

export default Publication
